module.exports = __webpack_public_path__ + "img/tutorial_img_2.c1eb1aa5.svg";